import { render, staticRenderFns } from "./RegionTree.vue?vue&type=template&id=a93efc32&"
import script from "./RegionTree.vue?vue&type=script&lang=js&"
export * from "./RegionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports